import { API } from '@/utils/api/api';

export const getBranchListApi = async () => {
  return API.get('/branch');
};

export const getSettingsApi = async () => {
  return API.get('/settings');
};

export const getDeviceListByBranchIdApi = async ({ branchId }) => {
  return API.get(`/Device/GetDevicesbyBranch/${branchId}`);
};

export const validateBranchAccessApi = async ({ branchId, accessCode }) => {
  return API.post(`/auth/verify/${branchId}/${accessCode}`);
};

export const registerDeviceApi = async (data) => {
  return API.post('/device/register', data);
};

export const updateDeviceMetaApi = async (data) => {
  return API.put('/Device/metadata', data);
};
